import { forwardRef } from 'react'

const SimpleCheckbox = forwardRef((props, ref) => {
  return (
    <label sx={{ display: 'block' }}>
      <input
        name={props.name}
        ref={ref}
        sx={{
          appearance: 'none',
          position: 'absolute',
          '&:checked + span': {
            '&::before': {
              transition: 'background-color 200ms, border-color 200ms',
            },
          },
          opacity: 0,
          variant: `elements.input.checkbox.variants.normal`,
        }}
        type='checkbox'
        defaultChecked={props.defaultChecked}
        value={props.value}
        onBlur={props.onBlur}
      />
      <span
        sx={{
          variant: 'elements.simple-checkbox.base-no-border',
        }}
      >
        {props.label}
      </span>
    </label>
  )
})

export default SimpleCheckbox
